<template>
  <BittsModal
    class="api-key-created-modal"
    title="API Key Created"
    variant="data"
    :width="600"
    primary-button-text="Done"
    primary-button-type="neutral"
    :show-secondary-button="false"
    @action="emit('closed')"
    @closed="emit('closed')"
  >
    <div class="api-key-created-modal__body">
      <BittsAlert
        color="warning"
        message="Copy this key now. It won't be shown again after leaving this page."
      />
      <BittsInput
        :model-value="rawKey"
        form-label="API Key"
        name="api-key-secret"
        :read-only="true"
        :allow-copy="true"
      />
    </div>
  </BittsModal>
</template>

<script setup lang="ts">
import { BittsAlert, BittsInput, BittsModal } from '@crossbeam/bitts';

import { useHead } from '@unhead/vue';

defineProps<{
  rawKey: string;
}>();

const emit = defineEmits<{
  closed: [];
}>();

useHead({ title: 'API key created - API Keys - API - Crossbeam' });
</script>

<style scoped lang="pcss">
@reference "../../../css/theme.css";

.api-key-created-modal.o-bitts-modal.bitts-modal--data:deep()
  .o-bitts-modal__content {
  @apply p-0 m-0;
}

.api-key-created-modal__body {
  @apply flex flex-col gap-16 p-20;
}
</style>
